// extracted by mini-css-extract-plugin
module.exports = {"container":"_3TGP1j6aIH0dm9NVj5sx-5","groupsList":"_3YP1L_7rCv5vQVhmpLy5Q1"};